/**
 * Sample form data for auto-fill on Monthly Report create page.
 * Fills periodYear, periodMonth, title — document (fileKey/documentUrl) must be provided by user.
 */
export type MonthlyReportFormSample = {
  periodYear: number;
  periodMonth: number;
  title: string;
};

const currentYear = new Date().getFullYear();

export const monthlyReportFormSamples: MonthlyReportFormSample[] = [
  {
    periodYear: currentYear,
    periodMonth: 1,
    title: "ລາຍງານປະຈໍາເດືອນມັງກອນ",
  },
  {
    periodYear: currentYear,
    periodMonth: new Date().getMonth() + 1,
    title: "ລາຍງານປະຈໍາເດືອນປັດຈຸບັນ",
  },
  {
    periodYear: currentYear - 1,
    periodMonth: 12,
    title: "ລາຍງານປະຈໍາເດືອນທີ່ແລ້ວ",
  },
  {
    periodYear: currentYear,
    periodMonth: 6,
    title: "ສະຫຼຸບກາງປີ",
  },
];
